import { ReactNode } from 'react';
import { AutomatiqSquareLogo } from 'src/svgs/AutomatiqSquareLogo';
import { AxsSquareLogo } from 'src/svgs/AxsSquareLogo';
import { FaxExchangeSquareLogo } from 'src/svgs/FaxExchangeSquareLogo';
import { GametimeSquareLogo } from 'src/svgs/GametimeSquareLogo';
import { GoTicketsSquareLogo } from 'src/svgs/GoTicketsSquareLogo';
import { LyteSquareLogo } from 'src/svgs/LyteSquareLogo';
import { SeatGeekSquareLogo } from 'src/svgs/SeatGeekSquareLogo';
import { StubHubSquareLogo } from 'src/svgs/StubHubSquareLogo';
import { TicketEvolutionSquareLogo } from 'src/svgs/TicketEvolutionSquareLogo';
import { TicketmasterSquareLogo } from 'src/svgs/TicketmasterSquareLogo';
import { TicketNetworkSquareLogo } from 'src/svgs/TicketNetworkSquareLogo';
import { TickPickSquareLogo } from 'src/svgs/TickPickSquareLogo';
import { VividSeatsSquareLogo } from 'src/svgs/VividSeatsSquareLogo';
import { Marketplace } from 'src/WebApiController';

const getMarketplaceSquareLogo = (
  marketplace: Marketplace | undefined | null,
  size?: number | string
): ReactNode => {
  switch (marketplace) {
    case Marketplace.VividSeats:
      return <VividSeatsSquareLogo width={size} height={size} />;
    case Marketplace.StubHub:
      return <StubHubSquareLogo width={size} height={size} />;
    case Marketplace.SeatGeek:
      return <SeatGeekSquareLogo width={size} height={size} />;
    case Marketplace.TickPick:
      return <TickPickSquareLogo width={size} height={size} />;
    case Marketplace.Ticketmaster:
      return <TicketmasterSquareLogo width={size} height={size} />;
    case Marketplace.AXS:
      return <AxsSquareLogo width={size} height={size} />;
    case Marketplace.FanXchange:
      return <FaxExchangeSquareLogo width={size} height={size} />;
    case Marketplace.Gametime:
      return <GametimeSquareLogo width={size} height={size} />;
    case Marketplace.TicketEvolution:
      return <TicketEvolutionSquareLogo width={size} height={size} />;
    case Marketplace.TicketNetwork:
      return <TicketNetworkSquareLogo width={size} height={size} />;
    case Marketplace.Automatiq:
      return <AutomatiqSquareLogo width={size} height={size} />;
    case Marketplace.Lyte:
      return <LyteSquareLogo width={size} height={size} />;
    case Marketplace.GoTickets:
      return <GoTicketsSquareLogo width={size} height={size} />;
    default:
      return marketplace;
  }
};

interface MarketplaceSquareLogoProps {
  marketplace?: Marketplace | undefined | null;
  size?: number | string;
}

export const MarketplaceSquareLogo = ({
  marketplace,
  size,
}: MarketplaceSquareLogoProps) => {
  return <>{getMarketplaceSquareLogo(marketplace, size)}</>;
};
